import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Branch {
  id: number;
  name: string;
  code?: string;
  city?: string;
  state?: string;
  is_head_office?: boolean;
}

interface TenantState {
  companySlug: string;
  companyName: string;
  branchId: number | null;
  branchName: string;
  branches: Branch[];
  setCompany: (slug: string, name?: string) => void;
  setBranch: (id: number | null, name: string) => void;
  setBranches: (branches: Branch[]) => void;
  clear: () => void;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      companySlug: localStorage.getItem('companySlug') || 'default',
      companyName: '',
      branchId: null,
      branchName: '',
      branches: [],
      setCompany: (slug, name) => {
        localStorage.setItem('companySlug', slug);
        set({ companySlug: slug, companyName: name || '' });
      },
      setBranch: (id, name) => set({ branchId: id, branchName: name }),
      setBranches: (branches) => set({ branches }),
      clear: () => {
        localStorage.removeItem('companySlug');
        set({ companySlug: 'default', companyName: '', branchId: null, branchName: '', branches: [] });
      },
    }),
    { name: 'smepro360-tenant' }
  )
);
